import { render, staticRenderFns } from "./detail-table.vue?vue&type=template&id=60fe0c30&scoped=true"
import script from "./detail-table.vue?vue&type=script&lang=js"
export * from "./detail-table.vue?vue&type=script&lang=js"
import style0 from "./detail-table.vue?vue&type=style&index=0&id=60fe0c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe0c30",
  null
  
)

export default component.exports